var _dec, _class, _class2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/** @module components/FolderSelector */

import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { observer, Observer, inject, Provider } from "mobx-react";
import AIOTree, { Spin } from "react-aiot";
import { Modal } from "./";
import Breadcrumb from "./Breadcrumb";
import { i18n, resolveIcon } from "../util";
import { BasicStore, createAllNode, createUnorganizedNode } from "../store";
import rmlOpts from "rmlopts";
import classNames from "classnames";
import $ from "jquery";
let FolderSelector = (_dec = inject("tree"), _dec(_class = observer(_class = (_class2 = class FolderSelector extends React.Component {
  constructor(_ref) {
    let {
      input,
      disabled,
      selected
    } = _ref;
    super(...arguments);
    this.getInputValue = () => {
      const val = this.inputObject.value;
      return val === "" || val === "all" ? "" : +val;
    };
    this.getMainStore = () => /* global rml */rml.store.tree.length && rml.store;
    /**
     * A node item should be an observer (mobx).
     */
    this.onTreeNodeRender = (createTreeNode, TreeNode, node) => {
      return /*#__PURE__*/React.createElement(Observer, {
        key: node.id
      }, () => createTreeNode(node));
    };
    /**
     * A node item icon is present as string.
     */
    this.onTreeNodeRenderIcon = icon => resolveIcon(icon);
    this.handleSelect = id => {
      let item;
      const previousValue = this.getInputValue();
      if (id === "") {
        // nullable
        item = this.props.tree.selected;
        item && item.setter(node => node.selected = false);
        this.props.tree.setter(t => t.selectedId = undefined); // Reset manually cause it can not listen when importing from snapshot
        item = null;
      } else {
        item = this.props.tree.getTreeItemById(id, false);
        if (!item) {
          return this.handleSelect(+rmlOpts.others.rootId);
        } else {
          item.setter(node => node.selected = true);
        }
      }
      this.inputObject.value = id;
      $(this.inputObject).data("node", item).trigger("folderSelected");
      this.setState({
        visible: false
      });
      previousValue !== id && this.props.onSelect && this.props.onSelect(item, this.inputObject);
      return item;
    };
    this.handleVisibleChange = () => {
      let visible = !this.state.visible;
      if (this._nullableNextVisibleChange) {
        visible = false;
      }
      this.setState({
        visible
      });
      this._nullableNextVisibleChange = false;
    };
    this.handleSelectNull = () => {
      this._nullableNextVisibleChange = true;
      this.handleSelect("");
    };
    this.inputObject = input || document.createElement("input");

    // Initial selection
    selected !== undefined && (this.inputObject.value = selected);
    this.state = {
      isTreeBusy: false,
      visible: false,
      disabled: (disabled ? ("" + disabled).split(",") : []).map(i => +i)
    };
  }

  /**
   * Set the selected id to the input field so it can be updated through the properties.
   */
  componentDidUpdate(prevProps) {
    const {
      input,
      selected
    } = this.props;
    if (!input && selected !== prevProps.selected) {
      this.handleSelect(prevProps.selected);
    }
  }

  /**
   * Initially set the value of the input field and breadcrumb path.
   *
   * @internal
   */
  async componentDidMount() {
    const val = this.getInputValue(),
      {
        tree,
        onFetchTree
      } = this.props;
    if (!this.props.nullable && (!val || val < 0)) {
      this.inputObject.value = -1;
    }
    this.setState({
      isTreeBusy: true
    });
    if (this.props.fetch) {
      try {
        // Check if global rml store holds already a tree
        const mainStore = this.getMainStore();
        if (mainStore) {
          tree.setTree(mainStore.getTreeSnapshot(), false, mainStore.slugs);
        } else {
          await tree.fetchTree();
        }
        onFetchTree && onFetchTree(tree);
      } catch (e) {
        console.log(e);
      }
    }

    // Disable nodes
    const {
      disabled
    } = this.state;
    if (disabled.length) {
      const fnDisabled = node => {
        if (disabled.indexOf(node.properties && +node.properties.type) > -1) {
          node.setter(n => n.className = "rml-deactivated");
        }
      };
      tree.nodes(fnDisabled);
      tree.nodes(fnDisabled, true);
    }

    // Modify this tree
    this.setState({
      isTreeBusy: false
    });

    // Preselect
    const item = this.handleSelect(val);
    this.props.onNodeInit && this.props.onNodeInit(item, this.inputObject);
  }
  render() {
    const {
        isTreeBusy,
        visible
      } = this.state,
      {
        className,
        style,
        editable,
        title,
        nullable,
        tree: {
          breadcrumb,
          selected,
          staticTree,
          tree
        },
        ignoreChildNodes,
        children,
        before,
        after
      } = this.props;
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Modal, {
      key: "modal",
      visible: visible && editable,
      wrapClassName: "rml-folder-selector",
      okText: i18n("ok"),
      cancelText: i18n("cancel"),
      title: title,
      onCancel: this.handleVisibleChange
    }, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(AIOTree, _extends({
      rootId: +rmlOpts.others.rootId,
      staticTree: staticTree.filter(_ref2 => {
        let {
          id
        } = _ref2;
        return id !== "all";
      }),
      tree: tree.length > 0 ? tree : [],
      isResizable: false,
      isFullWidth: true,
      creatable: {
        buttons: {}
      },
      toolbar: {
        buttons: {}
      },
      onSelect: this.handleSelect,
      renderItem: this.onTreeNodeRender,
      renderIcon: this.onTreeNodeRenderIcon,
      headline: /*#__PURE__*/React.createElement("span", {
        style: {
          paddingRight: 5
        }
      }, i18n("folders")),
      noFoldersTitle: i18n("noFoldersTitle"),
      ignoreChildNodes: ignoreChildNodes,
      noFoldersDescription: "",
      noSearchResult: i18n("noSearchResult"),
      theme: "wordpress",
      autoFocusSearchInput: true
    }, this.state)), children)), before, /*#__PURE__*/React.createElement("div", {
      key: "breadcrumb",
      className: classNames("rml-folder-edit", className, {
        "rml-deactivated": !editable
      }),
      style: style,
      onClick: this.handleVisibleChange
    }, /*#__PURE__*/React.createElement(Spin, {
      spinning: isTreeBusy
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      path: breadcrumb,
      closeable: selected && editable && nullable,
      onClose: this.handleSelectNull
    }))), after);
  }
}, _class2.defaultProps = {
  fetch: true,
  // Set to false if you want to set the selectable tree by yourself (store)
  nullable: false,
  editable: true,
  onSelect: undefined,
  onNodeInit: undefined,
  onFetchTree: undefined,
  ignoreChildNodes: false,
  before: undefined,
  after: undefined,
  title: undefined,
  selected: undefined,
  // Use this only without input
  input: undefined,
  // Input is optional, use selected for initial selected id
  disabled: "" // comma seperated list of types which are disabled
}, _class2)) || _class) || _class);
export { FolderSelector };

/**
 * Create the folder selector in a given target.
 *
 * @param {HTMLElement} target
 * @param {HTMLElement} input An input where the selected id is stored (usually input[type="hidden"])
 * @param {object} props The properties for FolderSelector control
 * @param {object} store
 * @returns {object} The created store
 */
export default function createFolderSelector(target, input, props, useStore) {
  const store = useStore || BasicStore.create({
    staticTree: [{
      ...createAllNode(),
      $visible: false
    }, createUnorganizedNode()]
  });
  ReactDOM.render( /*#__PURE__*/React.createElement(Provider, {
    tree: store
  }, /*#__PURE__*/React.createElement(FolderSelector, _extends({
    input: input
  }, props))), target);
  return store;
}